/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./aiBot.vue?vue&type=template&id=598af7f9&scoped=true&"
import script from "./aiBot.vue?vue&type=script&lang=js&"
export * from "./aiBot.vue?vue&type=script&lang=js&"
import style0 from "./aiBot.vue?vue&type=style&index=0&id=598af7f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598af7f9",
  null
  
)

export default component.exports